import { Card, Container, Grid2, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  //AccessibilityNew,
  //CrisisAlert,
  //DirectionsCarFilled,
  //ExpandLess,
  //ExpandMore,
  Newspaper,
  PieChartOutline,
  //ShutterSpeed,
} from "@mui/icons-material";
import {
  //blue,
  deepPurple,
  //green,
  grey,
  //orange,
  //red,
} from "@mui/material/colors";
import people from "../images/community.svg";
import speedometer from "../images/speed.svg";
import dangerous from "../images/alert.svg";
import { ApiService } from "../utils/ApiService";
import { notiError } from "../utils/notiUltils";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { io } from "socket.io-client";
import "animate.css";
import MonthlyMaximumNotificationArea from "./components/MonthlyMaximumNotificationArea";
import StandardData from "./components/StandardData";
import WeeklyOverview from "./components/WeeklyOverview";
import AllNotifications from "./components/AllNotifications";
import OverSpeed from "./components/OverSpeed";
import SmallDashboard from "./components/SmallDashboard";
import DailyEvent from "./components/DailyEvent";
import Performance from "./components/Performance";
import RealEvents from "./components/RealEvents";
import ShowEvent from "./components/ShowEvent";
import ShowAlarm from "./components/ShowAlarm";
dayjs.extend(utc);

const api = new ApiService(
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_API_URL_DEBUG
    : process.env.REACT_APP_API_URL_PRODUCT
);

function formatNumber(value, locale = "en-US") {
  return new Intl.NumberFormat(locale).format(value);
}

function App() {
  const theme = useTheme();
  const [eventData, setEventData] = useState([]);
  const [alarmData, setAlarmData] = useState([]);
  const [dataDash6, setDataDash6] = useState([0, 0]);
  const [dataDash7, setDataDash7] = useState([0, 0]);
  const [alarmReal, setAlarmReal] = useState(null);
  const [eventReal, setEventReal] = useState(null);

  const [reloadData, setReloadData] = useState(true);
  const [status, setStatus] = useState(true);
  const [status2, setStatus2] = useState(true);

  useEffect(() => {
    api
      .get("/top5Event", localStorage.getItem("token"))
      .then((data) => {
        const arr = [];

        data.forEach((element) => {
          const {
            CategoryID,
            CategoryName,
            LocationName,
            GpsDatetime,
            VehicleName,
          } = element;
          arr.push({
            image:
              CategoryID === 0
                ? people
                : CategoryID === 1
                ? speedometer
                : dangerous,
            title: CategoryName,
            text: LocationName,
            dateTime: dayjs(GpsDatetime).utc().format("YYYY-MM-DD HH:mm:ss"),
            vname: VehicleName,
          });
        });
        setEventData(arr);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });

    api
      .get("/top5Alarm", localStorage.getItem("token"))
      .then((data) => {
        const arr = [];
        data.forEach((element) => {
          const {
            CategoryID,
            CategoryName,
            AlarmName,
            GpsDatetime,
            VehicleName,
          } = element;
          arr.push({
            image:
              CategoryID === 0
                ? people
                : CategoryID === 1
                ? speedometer
                : dangerous,
            title: CategoryName,
            text: AlarmName,
            dateTime: dayjs(GpsDatetime).utc().format("YYYY-MM-DD HH:mm:ss"),
            vname: VehicleName,
          });
        });
        setAlarmData(arr);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });

    api
      .get("/dashboard6", localStorage.getItem("token"))
      .then((data) => {
        setDataDash6(data);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });

    api
      .get("/dashboard7", localStorage.getItem("token"))
      .then((data) => {
        setDataDash7(data);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  }, []);

  useEffect(() => {
    const socket =
      process.env.NODE_ENV === "development"
        //? io("https://gpslccm.com/")
        ? io()
        : io();
    socket.on("connect", () => {
      socket.emit("authen", localStorage.getItem("token"), (response) => {
        if (!response) {
          socket.close();
          localStorage.removeItem("token");
          window.location.href = "/authen";
        }
      });
    });
    let timeout;
    socket.on("area", (data) => {
      const { CategoryID, CategoryName, LocationName, dateTime, VehicleName } =
        data;
      if (timeout) {
        clearTimeout(timeout);
      }
      setStatus(false);
      timeout = setTimeout(() => {
        setEventData((old) => {
          const tmp = [...old];
          tmp.length >= 5 && tmp.pop();
          tmp.unshift({
            image:
              CategoryID === 0
                ? people
                : CategoryID === 1
                ? speedometer
                : dangerous,
            title: CategoryName,
            text: LocationName,
            dateTime: dayjs(dateTime).format("YYYY-MM-DD HH:mm:ss"),
            vname: VehicleName,
          });
          return tmp;
        });
        setStatus(true);
      }, 100);

      setEventReal(data);
    });

    socket.on("alarm", (data) => {
      //console.log(data);

      const { CategoryID, CategoryName, AlarmName, dateTime, VehicleName } =
        data;
      setStatus2(false);
      setTimeout(() => {
        setAlarmData((old) => {
          const tmp = [...old];
          tmp.length >= 5 && tmp.pop();
          tmp.unshift({
            image:
              CategoryID === 0
                ? people
                : CategoryID === 1
                ? speedometer
                : dangerous,
            title: CategoryName,
            text: AlarmName,
            dateTime: dayjs(dateTime).format("YYYY-MM-DD HH:mm:ss"),
            vname: VehicleName,
          });
          return tmp;
        });
      }, 100);

      setStatus(true);

      if (CategoryID === 1) {
        setDataDash6((old) => {
          const tmp = [...old];
          tmp[1] = tmp[1] += 1;
          return tmp;
        });
      }

      setAlarmReal(data);
      setReloadData(true);
    });

    return () => {
      socket.close();
    };
  }, []);

  return (
    <Card
      elevation={0}
      variant="outlined"
      sx={{
        flexGrow: 1,
        overflow: "auto",
        border: 0,
        borderRadius: 0,
        backgroundColor: theme.palette.mode === "dark" ? null : grey[200],
        p: 2,
      }}
      className="animate__animated animate__zoomIn animate__faster"
    >
      <Container maxWidth="xl">
        <Grid2 container spacing={3}>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            <MonthlyMaximumNotificationArea
              api={api}
              reloadData={reloadData}
              setReloadData={setReloadData}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 8 }}>
            {/* <Dashboard2 /> */}
            <StandardData api={api} />
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            <WeeklyOverview
              api={api}
              reloadData={reloadData}
              setReloadData={setReloadData}
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            {/* <AlarmSummary alarmReal={alarmReal} /> */}
            <AllNotifications
              api={api}
              reloadData={reloadData}
              setReloadData={setReloadData}
            />
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            <Grid2 container spacing={3}>
              <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <OverSpeed api={api} alarmReal={alarmReal} />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <SmallDashboard
                  icon={<PieChartOutline />}
                  iconColor={grey[500]}
                  title="เตือนความเร็ว"
                  value={formatNumber(dataDash6[1])}
                  percent={
                    dataDash6[0] === 0
                      ? dataDash6[1]
                      : parseFloat(
                          ((dataDash6[1] - dataDash6[0]) / dataDash6[0]) * 100
                        ).toFixed(1)
                  }
                  subtitle={"เตือนความเร็วรายสัปดาห์"}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <SmallDashboard
                  icon={<Newspaper />}
                  iconColor={deepPurple["A200"]}
                  title="พื้นที่เพิ่มใหม่"
                  value={formatNumber(dataDash7[1])}
                  percent={
                    dataDash7[1] === 0
                      ? 0
                      : dataDash7[0] === 0
                      ? 100
                      : parseFloat(
                          ((dataDash7[1] - dataDash7[0]) * 100) / dataDash7[0]
                        ).toFixed(1)
                  }
                  subtitle={"พื้นที่แจ้งเตือนรายปี"}
                />
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 12, md: 6, lg: 6 }}>
                <DailyEvent api={api} eventReal={eventReal} />
              </Grid2>
            </Grid2>
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            <Performance id={"performance_1"} api={api} alarmReal={alarmReal} />
          </Grid2>

          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            <RealEvents
              title={"เหตุการณ์"}
              status={status}
              data={eventData}
              detail={
                <ShowEvent api={api} disabled={eventData.length === 0 ? true : false} />
              }
            />
          </Grid2>
          <Grid2 size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 4 }}>
            <RealEvents
              title={"การแจ้งเตือน"}
              status={status2}
              data={alarmData}
              detail={
                <ShowAlarm api={api} disabled={alarmData.length === 0 ? true : false} />
              }
            />
          </Grid2>
        </Grid2>
      </Container>
    </Card>
  );
}

export default App;
